const sanitizeLine = (line = '') =>
  line
    .replace(/^[\-\*\d]+\s*[\.\)]?\s*/, '')
    .replace(/^[\u2022]/, '')
    .trim();

const splitToLines = (value) => {
  if (!value || typeof value !== 'string') return [];
  return value
    .split(/\r?\n+/)
    .map(sanitizeLine)
    .filter(Boolean);
};

const normalizeMistakes = (value) => {
  if (Array.isArray(value)) {
    return value
      .map((item) =>
        typeof item === 'string'
          ? { description: item }
          : { ...(item || {}), description: item?.description || '' },
      )
      .filter((item) => item.description?.trim());
  }
  return splitToLines(value).map((line) => ({ description: line }));
};

const normalizeStrengths = (value) => {
  if (Array.isArray(value)) {
    return value
      .map((item) =>
        typeof item === 'string' ? { description: item } : item,
      )
      .filter((item) => item.description?.trim());
  }
  return splitToLines(value).map((line) => ({ description: line }));
};

const toRawText = (value) => {
  if (!value) return '';
  if (typeof value === 'string') return value;
  if (Array.isArray(value)) {
    return value
      .map((item) => (typeof item === 'string' ? item : item?.description || ''))
      .filter(Boolean)
      .join('\n');
  }
  return '';
};

export const normalizeDiagramFeedback = (feedback = {}) => {
  const normalized = { ...feedback };
  normalized.mistakes = normalizeMistakes(feedback.mistakes);
  normalized.strengths = normalizeStrengths(feedback.strengths);
  normalized.mistakesRaw = toRawText(feedback.mistakes);
  normalized.strengthsRaw = toRawText(feedback.strengths);
  normalized.learning =
    typeof feedback.learning === 'string'
      ? feedback.learning
      : Array.isArray(feedback.learning)
        ? feedback.learning.join('\n')
        : '';
  
  // Handle new code evaluation fields
  if (feedback.codeAreasNeedingImprovement) {
    normalized.codeAreasNeedingImprovement = typeof feedback.codeAreasNeedingImprovement === 'string'
      ? feedback.codeAreasNeedingImprovement
      : Array.isArray(feedback.codeAreasNeedingImprovement)
        ? feedback.codeAreasNeedingImprovement.join('\n')
        : '';
  }
  
  if (feedback.missingDesignPatterns) {
    normalized.missingDesignPatterns = typeof feedback.missingDesignPatterns === 'string'
      ? feedback.missingDesignPatterns
      : Array.isArray(feedback.missingDesignPatterns)
        ? feedback.missingDesignPatterns.join('\n')
        : '';
  }
  
  if (feedback.designPatternOpportunities) {
    normalized.designPatternOpportunities = typeof feedback.designPatternOpportunities === 'string'
      ? feedback.designPatternOpportunities
      : Array.isArray(feedback.designPatternOpportunities)
        ? feedback.designPatternOpportunities.join('\n')
        : '';
  }
  
  if (feedback.missingFeatures) {
    normalized.missingFeatures = typeof feedback.missingFeatures === 'string'
      ? feedback.missingFeatures
      : Array.isArray(feedback.missingFeatures)
        ? feedback.missingFeatures.join('\n')
        : '';
  }
  
  return normalized;
};

